import React, { useMemo } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import {
  createSpecialId,
  getDescendantIds,
  ROOT_PARENT_ID,
} from "./helpers";

const initialValues = {
  title: "",
  href: "",
  parentId: ROOT_PARENT_ID,
};

const schema = Yup.object().shape({
  title: yupSchema.title,
  href: Yup.string().nullable(),
  parentId: Yup.string().required("والد را انتخاب کنید"),
});

export default function FormModalContent(props) {
  const { close, data, allSpecials = [], onSave } = props;

  const parentOptions = useMemo(() => {
    const descendants = data?.uid ? getDescendantIds(allSpecials, data.uid) : new Set();
    return [
      { id: ROOT_PARENT_ID, title: "بدون والد / سطح اول" },
      ...allSpecials
        .filter((item) => {
          if (item.uid === data?.uid) return false;
          if (descendants.has(item.uid)) return false;
          return item.level < 2;
        })
        .map((item) => ({
          id: item.uid,
          title: `${"— ".repeat(item.level)}${item.title}`,
        })),
    ];
  }, [allSpecials, data]);

  const form = [
    {
      _type: "textField",
      name: "title",
      label: "عنوان",
      autoFocus: true,
    },
    {
      _type: "textField",
      name: "href",
      label: "آدرس مقصد",
    },
    {
      _type: "autocomplete",
      name: "parentId",
      label: "والد",
      options: parentOptions,
      valueSelector: "id",
      labelSelector: "title",
      fast: false,
    },
  ];

  const handleSubmit = async (model, { setSubmitting }) => {
    let rowsToSave = [...allSpecials];

    if (data?.id) {
      rowsToSave = rowsToSave.map((item) => {
        if (item.id !== data.id) return item;
        return {
          ...item,
          title: model.title,
          href: model.href,
          parentId: model.parentId || ROOT_PARENT_ID,
        };
      });
    } else {
      const uid = createSpecialId();
      rowsToSave.push({
        uid,
        id: uid,
        title: model.title,
        href: model.href,
        parentId: model.parentId || ROOT_PARENT_ID,
        level: 0,
      });
    }

    await onSave(rowsToSave);
    setSubmitting(false);
    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "ویژه",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
}
